export default "__VITE_ASSET__C4V3k7Q3__"